export default __webpack_public_path__ + "static/media/img2.3e9a9b58.png";